<div class="upsell-cta py-4">
  <div class="upsell-cta__container mx-auto w-full p-4">
    <div class="desktop:flex text-center flex-col items-center">
      <button 
        data-qa="cta-yes" 
        class="upsell-cta__button-yes text-xl py-2.5 px-4 text-white font-semibold leading-tight border border-black desktop:w-7/12"
        (click)="nextPage(true)" 
        data-te="cta-yes"
        [innerHTML]="buttonYesText">
      </button>
      <div class="text-center my-1">- OR -</div>
      <button 
        data-qa="cta-no" 
        class="upsell-cta__button-no text-sm py-2.5 px-4 leading-tight font-semibold border border-black desktop:w-7/12"
        (click)="nextPage(false)" 
        [innerHTML]="buttonNoText" 
        data-te="cta-no">
      </button>
    </div>
  </div>
</div>
